import * as Yup from "yup";

import { Modal, OfficeButton } from "components";
import {
  UploadOfferDocument,
  UploadOfferDocumentVariables,
} from "_graphql/mutation/__generated__/UploadOfferDocument";

import { AttachSupportingDocumentsForm } from "components/forms";
import _ from "lodash";
import toast from "react-hot-toast";
import { uploadOfferDocument } from "_graphql/visal/mutations/offers";
import { useAppSearch } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export const validationSchema = Yup.object().shape({
  documents: Yup.array().notRequired(),
});

export default function AttachSupportingDocumentsContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const [upload, { loading }] = useMutation<
    UploadOfferDocument,
    UploadOfferDocumentVariables
  >(uploadOfferDocument, {
    refetchQueries: ["Offers"],
  });

  const form = useFormik<any>({
    initialValues: {
      documents: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (variables) => {
      upload({
        variables: {
          offerId: searchParams?.id || "",
          path: variables.documents.map((doc: any) => doc.file_path),
        },
      }).then((res) => {
        if (res.data?.uploadOfferDocument) {
          toast.success("Document uploaded successfully");
          setOpen(false);
          refetch && refetch();
        } else {
          toast.error("Error uploading document");
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="4xl"
      title="Attach Supporting Documents"
      description="Provide the documents to attach to the offer"
      renderActions={() => (
        <OfficeButton disabled={loading || form.values.documents.length < 1} type="submit" onClick={wrapClick(form.handleSubmit)}>
          {loading ? "Uploading..." : "Upload Document(s)"}
        </OfficeButton>
      )}
    >
      <AttachSupportingDocumentsForm form={form} />
    </Modal>
  );
}
